import { SubmissionError } from 'redux-form';

import find from 'lodash/find';
import pick from 'lodash/pick';
import forEach from 'lodash/forEach';

import endpoints from '../../../../config/endpoints';
import http from '../../../shared/http';
import { actions as rootActions } from '../../item';

const defaultInitialState = {
	isShow: false,
	cannedReplyId: null,
	fields: {
		title: '',
		text: ''
	}
};

const createCannedReplyForm  = ({
	namespace,
	stateNodeName
}) => {
	const OPEN_FORM = `${namespace}/${stateNodeName}-open-form`;
	const CLOSE_FORM = `${namespace}/${stateNodeName}-close-form`;
	const EDIT_REPLY = `${namespace}/${stateNodeName}-edit-reply`;

	const UPSERT_CANNED_REPLY_SUCCESS = `${namespace}/${stateNodeName}-upsert-success`;
	const UPSERT_CANNED_REPLY_ERROR = `${namespace}/${stateNodeName}-upsert-error`;

	const DELETE_CANNED_REPLY_SUCCESS = `${namespace}/${stateNodeName}-delete-success`;
	const DELETE_CANNED_REPLY_ERROR = `${namespace}/${stateNodeName}-delete-error`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = {
		openCannedReplyForm: () => ({
			type: OPEN_FORM
		}),

		closeCannedReplyForm: () => ({
			type: CLOSE_FORM
		}),

		editCannedReply: id => dispatch => {
			dispatch({ type: EDIT_REPLY, payload: id });
			dispatch(actions.openCannedReplyForm());
		},

		upsertCannedReply: formData => (dispatch, getState) => {
			const state = getState();
			const { data: { ticket } } = state[namespace];
			const { cannedReplyId } = state[namespace][stateNodeName];

			const request = http({
				url: cannedReplyId ?
					`${endpoints.THREADS.LIST}/canned-replies/${cannedReplyId}` :
					`${endpoints.THREADS.LIST}/canned-replies`,
				method: cannedReplyId ? 'put' : 'post',
				data: formData,
				actions: [UPSERT_CANNED_REPLY_SUCCESS, UPSERT_CANNED_REPLY_ERROR]
			});

			dispatch(rootActions.toggleProgressBar());

			return request(dispatch).then(action => {
				if (action.type === UPSERT_CANNED_REPLY_SUCCESS) {
					dispatch(actions.closeCannedReplyForm());
					return dispatch(rootActions.fetchData({ params: { id: ticket.id } }));
				}
				if (action.type === UPSERT_CANNED_REPLY_ERROR && action.payload.response.status === 400) {
					dispatch(rootActions.toggleProgressBar());
					const validationsErrors = {};
					const responseErrors = action.payload.response.data;

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			});
		},

		deleteCannedReply: id => (dispatch, getState) => {
			const state = getState();
			const { data: { ticket } } = state[namespace];

			if (!confirm('Please confirm deleting this canned reply.')) {
				return;
			}

			const request = http({
				url: `${endpoints.THREADS.LIST}/canned-replies/${id}`,
				method: 'delete',
				actions: [DELETE_CANNED_REPLY_SUCCESS, DELETE_CANNED_REPLY_ERROR]
			});

			dispatch(rootActions.toggleProgressBar());

			return request(dispatch).then(action => {
				if (action.type === DELETE_CANNED_REPLY_SUCCESS) {
					return dispatch(rootActions.fetchData({ params: { id: ticket.id } }));
				}
			});
		}
	};

	// reducers
	const reducers = {
		[OPEN_FORM]: state => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				isShow: true
			}
		}),

		[CLOSE_FORM]: state => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				cannedReplyId: null,
				isShow: false
			}
		}),

		[EDIT_REPLY]: (state, action) => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				cannedReplyId: action.payload
			}
		}),

		[DELETE_CANNED_REPLY_ERROR]: state => ({
			...state,
			[stateNodeName]: {
				...state[stateNodeName],
				error: true,
				showProgressBar: false
			}
		})
	};

	// selectors
	const selectors = {
		getFormValues: state => {
			if (!state[namespace]['data']) return null;

			const { data: { cannedReplies } } = state[namespace];
			const { fields, cannedReplyId } = state[namespace][stateNodeName];

			if (cannedReplyId) {
				const reply = find(cannedReplies, { id:  cannedReplyId});
				return pick(reply, Object.keys(fields));
			}

			return fields;
		},
		getShouldShowForm: state => state[namespace][stateNodeName].isShow
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createCannedReplyForm;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/threads/components/canned-reply-form/index.js